import { LvfTicketArticleNature } from "../../enum/daily-activity/lvf-ticket-article-nature";
import { EnumHelper } from "../../helper/enum.helper";
import { Guid } from "../../types/guid.type";
import { EntityBase, IEntityBaseInfo } from "../entity/entitybase";
import { ITaskCategoryInfo, TaskCategory } from "./task-category";
import { ITicketTypeTaskTypeInfo, TicketTypeTaskType } from "./ticket-type-task-type";

export interface ITicketTypeInfo extends IEntityBaseInfo {
  Label?: string;
  Description?: string;
  AuthorUid?: Guid;
  AuthorName?: string;
  TaskCategoryUid?: Guid;
  TaskCategory?: ITaskCategoryInfo;
  LvfTicketArticleNature?: LvfTicketArticleNature;
  ShowUnits?: boolean;
  Order?: number;
  TaskTypes?: ITicketTypeTaskTypeInfo[];
}

export class TicketType extends EntityBase {
  Label?: string;
  Description?: string;
  AuthorUid?: Guid;
  AuthorName?: string;
  TaskCategoryUid?: Guid;
  TaskCategory?: TaskCategory;
  LvfTicketArticleNature?: LvfTicketArticleNature;
  ShowUnits?: boolean;
  Order?: number;
  TaskTypes?: TicketTypeTaskType[];

  // Client side properties
  LvfTicketArticleNatureLabel?: string;

  constructor(info: ITicketTypeInfo) {
    super(info);

    this.Label = info.Label;
    this.Description = info.Description;
    this.AuthorUid = info.AuthorUid;
    this.AuthorName = info.AuthorName;
    this.TaskCategoryUid = info.TaskCategoryUid;
    this.TaskCategory = TaskCategory.createInstance(TaskCategory, info.TaskCategory);
    this.LvfTicketArticleNature = info.LvfTicketArticleNature;
    this.ShowUnits = info.ShowUnits ?? false;
    this.LvfTicketArticleNatureLabel = EnumHelper.getTranslationKey('LvfTicketArticleNature', LvfTicketArticleNature, this.LvfTicketArticleNature);
    this.Order = info.Order;
    this.TaskTypes = info.TaskTypes?.map(tt => new TicketTypeTaskType(tt)) || [];
  }
}

